import React, { useState } from "react";
import banner from "../../assets/img/forgot.gif";
import bannerDark from "../../assets/img/forgot-dark.gif";
import Button from "../../components/Button";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Input from "../../components/Input";
import { useSelector } from "react-redux";

const ForgotPassword = () => {
  const [value, setValue] = useState({});
  const handleChange = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(value);
  };
  // theme switer
  const theme = useSelector(state=>state.theme.theme);
  return (
    <>
      <Header />
      <div className="forgotpassword_page_wrapper">
        <div
          style={{ backgroundColor: "#fff" }}
          className="forgotpassword_card"
        >
          <div className="section_title">
            <h2>Forgot Password</h2>
          </div>
          <div className="forgotpassword_content">
            <form onSubmit={handleSubmit}>
              <div className="form_group">
                <Input
                  label="Enter your email"
                  type="text"
                  name="email"
                  placeholder="Enter your email"
                  onChange={handleChange}
                  className="emailid_input input_field"
                />
              </div>
              <Button type="submit" className="submit_btn glow neon">
                Send Link
              </Button>
            </form>
          </div>
        </div>
        <div className="forgotpassword_banner_img">
          <img src={theme ==="dark" ? bannerDark : banner} width="100%" alt="forgotpassword" />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ForgotPassword;
